document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.article-v2__content');
  const tocItems = document.getElementById('toc-items-sidebar');
  const sidebar = document.querySelector('.article-v2__sidebar');
  
  if (!content || !tocItems) return;
  
  const headings = content.querySelectorAll('h1, h2'); // Only main headers
  
  if (headings.length === 0) {
    // Hide sidebar if no headings
    if (sidebar) {
      sidebar.style.display = 'none';
      document.querySelector('.article-v2__main-content').style.maxWidth = '100%';
    }
    return;
  }
  
  // Generate Table of Contents
  let tocHTML = '<ul class="toc-list">';
  
  headings.forEach((heading, index) => {
    const id = 'heading-' + index;
    heading.id = id;
    
    const level = parseInt(heading.tagName.substring(1));
    const text = heading.textContent.trim();
    
    tocHTML += `<li class="toc-item toc-level-${level}">
      <a href="#${id}" class="toc-link" data-heading="${id}">${text}</a>
    </li>`;
  });
  
  tocHTML += '</ul>';
  tocItems.innerHTML = tocHTML;
  
  // Get all TOC links
  const tocLinks = tocItems.querySelectorAll('.toc-link');
  
  // Smooth scrolling for TOC links
  tocLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const headerOffset = 100; // Adjust based on your header height
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // Update active state
        updateActiveTocItem(this.getAttribute('data-heading'));
      }
    });
  });
  
  // Intersection Observer for highlighting current section
  const observerOptions = {
    rootMargin: '-20% 0px -70% 0px',
    threshold: 0
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        updateActiveTocItem(entry.target.id);
      }
    });
  }, observerOptions);
  
  // Observe all headings (H1 and H2 only)
  headings.forEach(heading => {
    observer.observe(heading);
  });
  
  // Function to update active TOC item
  function updateActiveTocItem(activeId) {
    tocLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('data-heading') === activeId) {
        link.classList.add('active');
      }
    });
  }
  
  // Initial active state (first heading)
  if (tocLinks.length > 0) {
    tocLinks[0].classList.add('active');
  }
  
  // Add reading progress indicator (optional)
  createReadingProgressBar();
  
  function createReadingProgressBar() {
    const progressBar = document.createElement('div');
    progressBar.className = 'reading-progress';
    progressBar.innerHTML = '<div class="reading-progress__bar"></div>';
    document.body.appendChild(progressBar);
    
    const progressBarFill = progressBar.querySelector('.reading-progress__bar');
    
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      
      progressBarFill.style.width = scrollPercent + '%';
    });
  }
});

// Add CSS for reading progress bar
const progressStyles = `
  .reading-progress {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  
  .reading-progress__bar {
    height: 100%;
    background: var(--color-button, #007acc);
    width: 0%;
    transition: width 0.1s ease;
  }
`;

// Inject progress bar styles
const styleSheet = document.createElement('style');
styleSheet.textContent = progressStyles;
document.head.appendChild(styleSheet); 